var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeartfill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5996 5.62913L12 6.16426L12.4004 5.62913C13.3204 4.39934 14.7949 3.59961 16.44 3.59961C19.2315 3.59961 21.5 5.87341 21.5 8.68961C21.5 9.82523 21.3189 10.8734 21.0043 11.8457L21.0032 11.849C20.249 14.2357 18.7035 16.1592 17.0354 17.5929C15.365 19.0285 13.6004 19.9479 12.4589 20.3363L12.4589 20.3362L12.4536 20.3381C12.3537 20.3734 12.1893 20.3996 12 20.3996C11.8107 20.3996 11.6463 20.3734 11.5464 20.3381L11.5464 20.3381L11.5411 20.3363C10.3996 19.9479 8.635 19.0285 6.96465 17.5929C5.29649 16.1592 3.75096 14.2357 2.99676 11.849L2.99677 11.8489L2.99572 11.8457C2.68114 10.8734 2.5 9.82523 2.5 8.68961C2.5 5.87341 4.76848 3.59961 7.56 3.59961C9.2051 3.59961 10.6796 4.39934 11.5996 5.62913Z",
    fill: "red",
    stroke: "#D10A5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartfill);
export default __webpack_public_path__ + "static/media/heartfill.b8e5720a137883d912a0fbf665237632.svg";
export { ForwardRef as ReactComponent };